let _version = '1.3.0-beta007'

if (process.env && (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'development-lite')) {
  _version = `${_version} [${process.env.BRANCH_NAME}]`
}

export default _version



//////////////////
// WEBPACK FOOTER
// ./version_1on1navi_web.js
// module id = 617
// module chunks = 1